// const productionSlope = require('json/productionSlope.json');

// function initializeSearchPlace() {
//   const searchInputForm = document.getElementById('input-search-address-form');
//   const searchInput = document.getElementById('input-search-address');

//   searchInputForm.onsubmit = function(event) {
//     event.preventDefault();
//   };

//   searchInput.oninput = function(event) {
//     console.log(event.target.value);
//   };
// }

export default {
  init() {
    // console.log(productionSlope);
  },
  finalize() {
    // initializeSearchPlace();
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/pageSolarCellCalculator.js